var _path, _text;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPresalesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 6V11M13 6V9M19.2 6V17M3 25H23C24.1046 25 25 24.1046 25 23V3C25 1.89543 24.1046 1 23 1H3C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 22,
    fill: "white",
    fontSize: 10,
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold"
  }, "PS")));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresalesIcon);
export default __webpack_public_path__ + "static/media/PresalesIcon.342b64a6b9c520e6d059127f1beaff7b.svg";
export { ForwardRef as ReactComponent };